function postFactory($http) {
  function getById(id) {
    return $http.get(`/admin/post/${id}`).then(r => r.data);
  }
  function getAll(query) {
    return $http.get('/admin/post', { params: query }).then(r => r.data);
  }
  return { getById, getAll };
}
postFactory.$inject = ['$http'];
export default postFactory;



// WEBPACK FOOTER //
// ./client/app/components/post/post.factory.js